import React, { useState } from "react"
import Nav from "react-bootstrap/Nav";
import MagazineMenu from "./MagazineMenu";
import DesignersMenu from "./DesignersMenu";
import connect from "react-redux/es/connect/connect";
import GiftsMenu from "./GiftsMenu";
import SalesMenu from "./SalesMenu";
import {generateCollectionPrefix, generateCollections} from "./helpers";
import {getCookie} from "../common/utils";
import ItemsMenuSimplified from "./ItemsMenuSimplified";
import config from "../../config";

const HeaderMenuItem = React.memo((props) => {
    const [activeKey, setActiveKey] = useState('');
    const [expandedMenu, setExpandedMenu] = useState({});

    const showMenus = () => {
        setActiveKey(menu_item.key);
        setExpandedMenu(menu_item.mouse_over);
    }

    const hideMenus = () => {
        setActiveKey('');
        setExpandedMenu('');
    }

    const { menu_item, mobile, designers, magazines, vault_articles, user_profile } = props;
    const expandedMenuIdentifier = Object.keys(expandedMenu)[0];
    const header_menu_item_class = menu_item.className ? ' ' + menu_item.className : '';
    const collections = generateCollections(menu_item);
    const collections_prefix = generateCollectionPrefix(collections);
    const location = new URL(window.location);
    const showForYouNewLabel = getCookie('show_new_arrivals_pop_up');

    if (menu_item.mouse_over && !mobile) {
        if(!user_profile?.is_b2b && menu_item.key === 'wholesale'){
            return (
                <Nav.Item
                    className={`header-menu-nav__menu-item${header_menu_item_class} nav-link`}
                >
                    <a
                        href={`${config.host_rebag}/rebagforbusiness/`}
                        className={location.pathname.indexOf(menu_item.url_slug) !== -1 ? 'active' : ''}
                    >
                        {menu_item.title}
                    </a>
                </Nav.Item>
            )
        }

        return (
            <Nav.Item
                className={`header-menu-nav__menu-item${header_menu_item_class} nav-link`}
                onMouseOver={() => showMenus()}
                onFocus={() => showMenus()}
                onMouseLeave={() => hideMenus()}
                onBlur={() => hideMenus()}
            >
                <a className={`${(menu_item.key === activeKey || location.pathname.indexOf(menu_item.url_slug) !== -1 || (location.pathname === "/collections/" && menu_item.key === "designers")) ? 'active' : ''}`} href={menu_item.href + (menu_item.sort || "")}>
                    {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                    {menu_item.title}
                </a>

                {expandedMenuIdentifier === 'show_designers_menu' &&
                <DesignersMenu
                    menu_item={menu_item}
                    designers={designers}
                    show_designers_menu={true}
                />
                }

                {expandedMenuIdentifier === 'show_magazine_menu'  &&
                    <MagazineMenu
                        articles={magazines}
                        vault_articles={vault_articles}
                    />
                }

                {expandedMenuIdentifier === 'show_gifts_menu' &&
                    <GiftsMenu className="red-text" />
                }

                {expandedMenuIdentifier === 'show_sales_menu' &&
                    <SalesMenu collections={menu_item.collections} menu_item={menu_item}/>
                }

                {['show_bags_menu','show_accessories_menu', 'show_watches_menu', 'show_jewelry_menu', 'show_apparel_menu','show_shoes_menu'].includes(expandedMenuIdentifier) &&
                <ItemsMenuSimplified
                    menu_item={menu_item}
                    collections={collections}
                    collections_prefix={collections_prefix}
                    show_designers_menu={false}
                />
                }
            </Nav.Item>
        )
    }
    if (menu_item.show_mobile) {
        if(!user_profile?.is_b2b && menu_item.key === 'wholesale'){
           return (
               <Nav.Item
                   className={`header-menu-nav__menu-item${header_menu_item_class} nav-link`}
               >
                   <a
                       href={`${config.host_rebag}/rebagforbusiness/`}
                       className={location.pathname.indexOf(menu_item.url_slug) !== -1 ? 'active' : ''}
                   >
                       {menu_item.title}
                   </a>
               </Nav.Item>
           )
        }

        return (
            <Nav.Item
                className={`header-menu-nav__menu-item${header_menu_item_class} nav-link`}
            >
                <a
                    href={menu_item.href + (menu_item.sort || '')}
                    className={location.pathname.indexOf(menu_item.url_slug) !== -1 ? 'active' : ''}
                >
                    {menu_item.icon && <span className={`${menu_item.icon} icon`}/>}
                    {menu_item.title}
                    {showForYouNewLabel && menu_item.key === 'for_you' &&
                        <span className="header-menu-nav__menu-item--new">
                            New
                        </span>
                    }
                </a>
            </Nav.Item>
        )
    }
    return null;
})

const mapStateToProps = function (state) {
    const {designers, magazines, stores} = state.appReducer.init || {designers: [], magazines: [], stores: []};
    const {user_profile} = state.myAccountReducer;
    return {designers, magazines, stores, user_profile};
};

export default connect(mapStateToProps, null)(HeaderMenuItem);